<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-12">
    <div class="d-flex align-items-center flexmob">
      <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600"  (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex align-items-center">
        <div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="clipboard-text" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Statement of Trustees’ Responsibility
          </h4>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-12 p-0 m-t-12">
  <mat-card class="">
    <mat-card-content>
    <p class="f-s-14">The trustees are responsible for providing stakeholders with accurate information regarding the charity’s activities, achievements, and governance.</p>
    <div class=""> </div>
    <div class="row align-items-start">
      <div class="col-lg-6">
        <h4 class="f-s-14">Do you want to include Statement of Trustees’ Responsibility in your Accounts?</h4>
      </div>
      <div class="col-lg-6 text-left">
        <div class="ar d-flex flex-column" style="">
          <mat-radio-button value='yes' [checked]="showContent" (change)="setVisibility($event)">Yes</mat-radio-button>
          <mat-radio-button value='no' [checked]="!showContent" (change)="setVisibility($event)">No</mat-radio-button>
        </div>
      </div>
    </div>

  </mat-card-content>
    <!--<mat-card-content>
      <p class="f-s-14">
        The TAR provides stakeholders with important information about your charity's activities, achievements, and governance.
      </p>

      <div class="row align-items-start">
        <div class="col-lg-6">
          <h4 class="f-s-14">Do you want to include Trust Annual Report in your Accounts?</h4>
        </div>

        <div class="col-lg-6 text-left">
          <mat-radio-group [(ngModel)]="selectedReportOption" (change)="setVisibility($event)">
            <mat-radio-button value="yes">Yes</mat-radio-button>
            <mat-radio-button value="no">No</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
    </mat-card-content>-->

  </mat-card>
</div>
  

<div *ngIf="showContent">
  <form [formGroup]="form">
    <mat-card-content class="p-0 bg-white" style="border-radius: 12px;">
      <div class="p-16 b-b-1 justify-content-center align-items-center">

        <!-- Rich Text Editor -->
        <mat-card-content class="bg-white m-t-0 p-x-0">
          <div class="p-b-10 d-flex justify-content-end">
            <button mat-flat-button color="primary" (click)="SetDefault()" class="bg-none text-primary" style="height: 30px;" [disabled]="!UserRoleAccess?.m1Create">
              <span class=""> Default Statement </span>
            </button>
          </div>
          <div class="NgxEditor__Wrapper" style="min-height: 220px;" >
            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor [editor]="editor"
                        formControlName="trusteeStatement" (input)="MarkDirty()"
                        placeholder="Type here...">
            </ngx-editor>
          </div>
        </mat-card-content>
        <!--<mat-error style="padding-left:inherit !important" *ngIf="form.get('trusteeStatement')?.value== '<p></p>' && form.get('trusteeStatement')?.touched">
          Please enter data12 [ngClass]="{ 'invalid-editor': form.get('trusteeStatement')?.value== '<p></p>' && form.get('trusteeStatement')?.touched }"
        </mat-error>-->


        <!-- Trustee Declaration -->
        <mat-card-content class="b-1 m-t-12 p-x-0">
          <mat-card-title class="p-x-14 b-b-1 mat-mdc-card-title" style="background: aliceblue;">
            <div class="d-flex align-items-center p-y-20">
              <div class="icon-holder">
                <i-tabler class="icon-24 m-r-0 primary-color-dark" name="circle-check"></i-tabler>
              </div>
              <div>
                <h4 class="f-s-16 primary-color-dark f-w-600 d-block">Trustee Declaration</h4>
                <p class="f-s-14 m-0">Approve and sign the report on behalf of the board of trustees.</p>
              </div>
            </div>
          </mat-card-title>

          <div class="p-x-14 m-y-10 row">
            <!-- Trustee Name -->
            <div class="col-lg-6">
              <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-24 m-r-0 primary-color-dark" name="user"></i-tabler>
                  <h5 class="f-w-600 f-s-14">Trustee Name<span class="text-danger"> *</span></h5>
                </div>
              </mat-label>
              <!--<mat-form-field appearance="outline" class="w-100">
          <mat-select formControlName="trusteeName" placeholder="Select Trustee Name">
            <mat-option value="John Smith">Select a Trustee</mat-option>
            <mat-option value="John Smith">John Smith</mat-option>
            <mat-option value="Jane Doe">Jane Doe</mat-option>
          </mat-select>
        </mat-form-field>-->

              <mat-form-field appearance="outline" class="w-100">
                <mat-select formControlName="trusteeID" placeholder="Select Trustee"  (blur)="onTrusteeChange($event,'blur');MarkDirty()" (selectionChange)="onTrusteeChange($event,'selected');MarkDirty()">
                  <!--<mat-option value="" disabled>Select a Trustee</mat-option>-->
                  <mat-option *ngFor="let trustee of trusteesList" [value]="trustee.trustee_Id">
                    {{ trustee.name }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="this.form.get('trusteeID').getRawValue()==0 &&form.get('trusteeID')?.touched">
                  Select a Trustee
                </mat-error>
              </mat-form-field>


            </div>

            <!-- Approval Date -->
            <div class="col-lg-6">
              <mat-label class="f-s-14 f-w-600 m-b-8 d-block m-t-12">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-24 m-r-10 primary-color-dark" name="calendar"></i-tabler>
                  <h5 class="f-w-600 f-s-14">Approval Date <span class="text-danger"> *</span></h5>
                </div>
              </mat-label>

              <mat-form-field appearance="outline" class="w-100">
                <input matInput appTextMaskDate [matDatepicker]="picker" placeholder="dd/mm/yyyy" formControlName="approvalDate" (blur)="vldtrusteedateofapp($event);MarkDirty()" (dateChange)="vldtrusteedateofapp($event);MarkDirty()" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="form.get('approvalDate').hasError('required')&& form.get('approvalDate')?.touched&& !this.form.get('approvalDate')?.getRawValue()">
                  Approval Date required
                </mat-error>
                <mat-error *ngIf="form.get('approvalDate').hasError('IsAfterToday')">
                  Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
                <mat-error *ngIf="form.get('approvalDate').hasError('InvalidDate')">
                  Approval Date is invalid
                </mat-error>
                <mat-error *ngIf="form.get('approvalDate').hasError('IsBeforeAP')">
                   Approval Date should be on or between Accounting Period Start and Today's Date
                </mat-error>
                <mat-error *ngIf="form.get('approvalDate').hasError('IsBefore2015')">
                  Approval Date should be after 01-01-2015
                </mat-error>
              </mat-form-field>

              <!--<mat-form-field appearance="outline" class="w-100">

          <input matInput [matDatepicker]="picker1" placeholder="dd/mm/yyyy" class="date-left" appTextMaskDate formControlName="approvalDate" (dateChange)="vldtrusteedateofapp($event)"   />
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>-->
            </div>
          </div>
        </mat-card-content>
      </div>
    </mat-card-content>
  </form>
</div>


<hr class="m-t-24" style="opacity:0.2" />
<div class="row p-16">

  <div class="col-sm-12 col-md-4 m-b-16">
    <button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToTAR()">
      <div class="d-flex text-black">
        <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
      </div>
    </button>
  </div>
  <div class="col-sm-12 col-md-8 m-b-16" align="right">
    <!--<button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
      <div class="d-flex text-black">
        <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
      </div>
    </button>-->
    <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="save()" [disabled]="!UserRoleAccess?.m1View">
      <div class="d-flex">
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-right"></i-tabler><span class="f-s-14 text-dark">Next</span>
      </div>
    </button>
  </div>
</div>
